import React from 'react'
import { Wrapper } from '@farewill/ui'

import { PRODUCTS } from 'lib/products/constants'
import ExplainerLayout from 'components/ExplainerLayout'
import CallUsTodayCta from 'components/CallUsTodayCta'

import data from './data'

const Serving = ({
  imagePosition = 'right',
}: {
  imagePosition?: 'left' | 'right'
}): React.ReactElement => (
  <ExplainerLayout
    title={data.title}
    description={data.subtitle}
    imagePosition={imagePosition}
    additionalContent={
      <Wrapper>
        <CallUsTodayCta product={PRODUCTS.FUNERAL} />
      </Wrapper>
    }
    imagePath={data.image}
    imageWidth={200}
    imageCentered
  />
)

export default Serving
